<template>
  <div>
    <view-options elementId="SocialMediaPost" />
    <div class="product-view" id="SocialMediaPost">
      <div class="lds-ellipsis" v-if="loadingData">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div class="social-networks-wrapper">
        <mq-layout mq="laptop+">
          <div class="facts">
            <div class="left">
              <h2>¿Sabía que...?</h2>
              <!-- <p>Lo que logra con Facebook e Instagram Ads</p> -->
            </div>
            <ul>
              <li>
                Más de 1/3 de los usuarios de Instagram utilizan la aplicación
                para comprar un producto online.
              </li>
              <li>
                Facebook cuenta con más de 10 formatos de publicidad para
                diversificar tu oferta.
              </li>
              <li>
                Campañas realizadas tanto en Facebook como en Instagram
                generalmente resultan en un mayor número de clicks y llamadas
                que aquellas que se ejecutaron en una sola plataforma.
              </li>
            </ul>
          </div>
        </mq-layout>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            label="Interacción con la publicación"
            name="POST_ENGAGEMENT"
            v-show="campaigns_objectives.includes('POST_ENGAGEMENT')"
          >
            <CardContainerMain
              :series="metricsCustom.series"
              :header="metricsCustom.dates"
              :totals="metricsCustom.totals"
              :info="{
                title: 'Interacciones con la publicación',
                name: 'Interacciones'
              }"
            />
          </el-tab-pane>
          <el-tab-pane
            label="Generar Likes en la página"
            name="PAGE_LIKES"
            v-show="
              campaigns_objectives.includes('PAGE_LIKES') &&
                activeName == 'PAGE_LIKES'
            "
          >
            <CardContainerMain
              :series="metricsCustom.series"
              :header="metricsCustom.dates"
              :totals="metricsCustom.totals"
              :info="{
                title: 'Generar Likes en la página',
                name: 'Me gusta'
              }"
            />
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="widget-area demographic-data">
        <h3 class="widget-title">Datos demográficos sobre sus usuarios</h3>
        <section class="widget">
          <h5 class="widget-title">Género</h5>
          <CardDateDemogr
            :headers="metricDemogra.headers"
            :series="metricDemogra.series"
          />
        </section>
        <section class="widget">
          <h5 class="widget-title">Edad</h5>
          <CardDateDemogr
            :headers="metricDemograAge.headers"
            :series="metricDemograAge.series"
          />
        </section>
        <section class="widget">
          <h5 class="widget-title">Interacción por plataforma</h5>
          <CardCharPlatform
            :headers="this.metricPlatforms.headers"
            :series="this.metricPlatforms.series"
          />
        </section>
      </div>
      <mq-layout
        mq="laptop+"
        v-show="facebooPreviews.length || facebooPreviewsInstagram.length"
      >
        <div class="ads">
          <h3 class="widget-title">
            Un vistazo a sus top 10 de anuncios en redes sociales
          </h3>
          <div class="two-column">
            <card
              class="ad-listing social-ad-preview"
              v-show="facebooPreviews.length"
            >
              <h3>Facebook</h3>
              <ContainerIframe :previews="facebooPreviews" />
            </card>
            <card
              class="ad-listing social-ad-preview"
              v-show="facebooPreviewsInstagram.length"
            >
              <h3>Instagram</h3>

              <ContainerIframe :previews="facebooPreviewsInstagram" />
            </card>
          </div>
        </div>
      </mq-layout>
    </div>
    <div class="export" id="export"></div>
  </div>
</template>
<script>
import { validateProductExpirationDate, sortArrayObjectDesc } from "../../util";
import CardContainerMain from "@/components/Card/CardContainerMain.vue";
import CardCharPlatform from "@/components/Card/CardCharPlatform.vue";
import ContainerIframe from "@/components/Card/ContainerIframe.vue";
import CardDateDemogr from "@/components/Card/CardDateDemogr.vue";
import { getConfig } from "@/services/business_config.service.js";
import FacebookMetrics from "@/services/facebook-metrics.js";
import ViewOptions from "@/components/ViewOptions.vue";

export default {
  name: "social-network",
  components: {
    ViewOptions,
    CardContainerMain,
    ContainerIframe,
    CardDateDemogr,
    CardCharPlatform
  },
  data() {
    return {
      loadingData: false,
      facebookMetrics: [],
      facebookMetricsGetPreviews: [],
      tabNameActive: null,
      objetivesMetrics: [],
      metricsSelected: [],
      facebookObjectives: [],
      metricDemogra: {
        headers: ["Masculino", "Femenino", "No Especificado"],
        series: [0, 0, 0]
      },
      metricDemograAge: {
        headers: [
          "18 - 24",
          "25 - 34",
          "35 - 44",
          "45 - 54",
          "55 - 64",
          "65 ó más"
        ]
      },
      metricsCustom: {
        series: []
      },
      facebooPreviews: [],
      facebooPreviewsInstagram: [],
      metricPlatforms: {
        headers: [],
        series: [0, 0]
      },
      facebooTotalClick: 0,
      facebooTotalReach: 0,
      facebooTotalImpressions: 0,
      activeName: "POST_ENGAGEMENT",
      optionsHeaders: [],

      facebookAds: [],
      instagramAds: [],
      campaigns_objectives: []
    };
  },
  async created() {
    const facebookObjectives = await getConfig("objetive-config.json");
    this.facebookObjectives = facebookObjectives.objectives || [];
  },
  methods: {
    activeByCampaigsObjective() {
      if ((this.campaigns_objectives || []).includes("PAGE_LIKES")) {
        this.activeName = "PAGE_LIKES";
      }

      if ((this.campaigns_objectives || []).includes("POST_ENGAGEMENT")) {
        this.activeName = "POST_ENGAGEMENT";
      }
    },
    handleClick(tab) {
      this.getMetricsByObjective(tab.name);
      this.tabNameActive = tab.name;
    },

    async getFacebookMetrics(product) {
      this.loadingData = true;
      try {
        let objetives = [];
        const metrics = await new FacebookMetrics(this).getMetrics(product);

        this.campaigns_objectives = [];
        this.campaigns_objectives = (metrics.metrics || []).map(c => {
          if (!this.campaigns_objectives.includes(c.objetive))
            return c.objetive;
        });

        for (let tab in document.querySelectorAll(
          ".el-tabs__nav .el-tabs__item"
        )) {
          try {
            document.querySelectorAll(".el-tabs__nav .el-tabs__item")[
              tab
            ].style.display = "none";
          } catch (error) {
            console.log(error);
          }
        }

        for (let tab in this.campaigns_objectives) {
          try {
            document.getElementById(
              "tab-" + this.campaigns_objectives[tab]
            ).style.display = "inline-block";
          } catch (error) {
            console.log(error);
          }
        }

        this.facebookMetrics = metrics.metrics;
        this.facebookMetricsGetPreviews = metrics.ads;
        (metrics.metrics || []).filter(m => {
          if (!objetives.includes(m.objetive)) objetives.push(m.objetive);
          return m;
        });

        this.objetivesMetrics = objetives;
      } catch (error) {
        this.loadingData = false;
      }
      this.loadingData = false;
    },

    getMetricsPreviews() {
      let previews = this.facebookMetricsGetPreviews;
      let objectiveActive = this.tabNameActive || this.activeName;

      const facebookObjective = this.facebookObjectives.find(objective => {
        return objectiveActive == objective.objetiveCode;
      });

      const filteredPreviews = previews.filter(item =>
        facebookObjective.adsObjectives
          ? facebookObjective.adsObjectives.includes(item.objective)
          : facebookObjective.objetiveCode == item.objective
      );

      previews = sortArrayObjectDesc(filteredPreviews, "impressions").slice(
        0,
        10
      );

      this.facebooPreviews = (previews || []).filter(
        p => p.publisher_platform != "instagram"
      );
      this.facebooPreviewsInstagram = (previews || []).filter(
        p => p.publisher_platform == "instagram"
      );
      let facebook = 0;
      let instagram = 0;
      this.metricPlatforms.series = [0, 0];
      for (let prev of previews) {
        if (prev.publisher_platform == "instagram")
          instagram = instagram + parseInt(prev.impressions);
        else facebook = facebook + parseInt(prev.impressions);
      }
      this.metricPlatforms.series = [facebook, instagram];
    },
    getMetricsByObjective(objetive) {
      this.metricsSelected = [];

      this.metricsSelected = (this.facebookMetrics || []).filter(m => {
        return m.objetive == objetive;
      });
      this.activeByCampaigsObjective();
    }
  },
  async mounted() {
    await this.getFacebookMetrics({
      subcribeid: this.$route.params.subscriberId,
      countryid: this.$route.params.businessUnitId,
      date_start: this.date_start,
      date_end: this.date_end
    });
  },
  watch: {
    facebookObjectives: {
      async handler() {
        await this.getMetricsPreviews();
      },
      deep: true
    },
    campaigns_objectives: {
      handler() {
        this.activeByCampaigsObjective();
      },
      deep: true
    },
    facebookMetrics: {
      async handler() {
        await this.getMetricsByObjective(this.activeName);
      },
      deep: true
    },
    date_start: {
      async handler() {
        await this.getFacebookMetrics({
          subcribeid: this.$route.params.subscriberId,
          countryid: this.$route.params.businessUnitId,
          date_start: this.date_start,
          date_end: this.date_end
        });
      },
      deep: true
    },
    date_end: {
      async handler() {
        await this.getFacebookMetrics({
          subcribeid: this.$route.params.subscriberId,
          countryid: this.$route.params.businessUnitId,
          date_start: this.date_start,
          date_end: this.date_end
        });
      },
      deep: true
    },
    metricsSelected: {
      handler(metrics) {
        this.metricsCustom = {
          series: [],
          dates: [],
          totals: {}
        };
        this.metricPlatforms.series = [0, 0];
        this.metricDemogra.series = [0, 0, 0];
        this.facebooPreviews = [];
        this.metricDemograAge.series = [0, 0, 0, 0, 0, 0];
        if (metrics.length) {
          //config date
          // let data = undefined;

          //config info
          this.metricsCustom.totals = metrics.reduce((prev, next) => ({
            clicks: parseInt(prev.clicks || 0) + parseInt(next.clicks || 0),
            impressions:
              parseInt(prev.impressions || 0) + parseInt(next.impressions || 0),
            reach: parseInt(prev.reach || 0) + parseInt(next.reach || 0),
            fresult: parseInt(prev.fresult || 0) + parseInt(next.fresult || 0)
          }));

          //get previews
          let female = 0;
          let unknown = 0;
          let male = 0;
          let gender_total = 0;
          let age_18_24 = 0;
          let age_25_34 = 0;
          let age_35_44 = 0;
          let age_45_54 = 0;
          let age_55_64 = 0;
          let age_mas_65 = 0;
          let groupBy = function(miarray, prop) {
            return miarray.reduce(function(groups, item) {
              var val = item[prop];
              groups[val] = groups[val] || {
                clicks: 0,
                fresult: 0,
                impressions: 0
              };
              groups[val].clicks += parseInt(item.clicks || 0);
              groups[val].fresult += parseInt(item.fresult || 0);
              groups[val].impressions += parseInt(item.impressions || 0);

              return groups;
            }, {});
          };
          const metricBygrups = groupBy(metrics, "enddate");

          let _metrics = {
            clicks: [],
            fresult: [],
            impressions: [],
            date: []
          };

          for (let [key, value] of Object.entries(metricBygrups)) {
            _metrics.date.push(key);
            _metrics.clicks.push(value.clicks);
            _metrics.fresult.push(value.fresult);
            _metrics.impressions.push(value.impressions);
          }

          // function changeLableObjective(objetive) {
          //   if (objetive == "") return "clicks";
          // }
          this.metricsCustom.series = [];
          _metrics.date = (_metrics.date || []).sort(function(a, b) {
            if (new Date(a) > new Date(b)) {
              return 1;
            }
            if (new Date(a) < new Date(b)) {
              return -1;
            }
            // a must be equal to b
            return 0;
          });

          this.metricsCustom.series = [
            {
              name: "Impresiones",
              data: _metrics.impressions
            },
            {
              name: "",
              data: _metrics.fresult
            }
          ];
          this.metricsCustom.dates = _metrics.date;

          for (let gender of metrics) {
            gender_total = gender_total + parseInt(gender.impressions || 0);

            if (gender.gender == "female")
              female = female + parseInt(gender.impressions || 0);
            if (gender.gender == "unknown")
              unknown = unknown + parseInt(gender.impressions || 0);
            if (gender.gender == "male")
              male = male + parseInt(gender.impressions || 0);

            //organizar por edad
            if (gender.ages == "18-24")
              age_18_24 = age_18_24 + parseInt(gender.impressions || 0);
            else if (gender.ages == "25-34")
              age_25_34 = age_25_34 + parseInt(gender.impressions || 0);
            else if (gender.ages == "35-44")
              age_35_44 = age_35_44 + parseInt(gender.impressions || 0);
            else if (gender.ages == "45-54")
              age_45_54 = age_45_54 + parseInt(gender.impressions || 0);
            else if (gender.ages == "55-64")
              age_55_64 = age_55_64 + parseInt(gender.impressions || 0);
            else age_mas_65 = age_mas_65 + parseInt(gender.impressions || 0);
          }

          this.metricDemograAge.headers = [
            "18 - 24",
            "25 - 34",
            "35 - 44",
            "45 - 54",
            "55 - 64",
            "65 ó más"
          ];

          this.metricDemograAge.series = [
            age_18_24,
            age_25_34,
            age_35_44,
            age_45_54,
            age_55_64,
            age_mas_65
          ];

          this.metricDemogra.headers = [
            "Masculino",
            "Femenino",
            "No Especificado"
          ];
          this.metricDemogra.series = [male, female, unknown];

          let campaigns = metrics.map(m => parseInt(m.campaign_id));

          this.getMetricsPreviews(campaigns);
        }
      },
      deep: true
    }
  },
  computed: {
    date_start() {
      const finalDate = this.$store.state.subscriber.date1;
      return this.$store.state.subscriber.date2 > finalDate
        ? finalDate
        : this.$store.state.subscriber.date2;
    },
    date_end() {
      const { productId } = this.$route.params;
      const products = this.$store.state.subscriber.products;
      const validatedFinalDate = validateProductExpirationDate(
        products,
        productId,
        this.$store.state.subscriber.date1
      );

      return validatedFinalDate;
    }
  }
};
</script>
<style lang="scss" scoped>
.export {
  display: none;
}
.social-networks-wrapper {
  .line-chart-data {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .data {
      width: 100%;
      text-align: center;
      p {
        margin-bottom: 0;
      }
      h1 {
        color: $highlight-color;
        font-weight: $font-bold;
      }
    }
  }
  .facts {
    background: linear-gradient(96.6deg, #3c5a99 5.18%, #ed4b62 98.32%);
    padding: 40px;
    display: grid;
    grid-template-columns: 200px 1fr;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    align-items: center;
    margin-bottom: 20px;
    h2,
    p,
    li {
      color: #fff;
    }
    h2 {
      margin-bottom: 5px;
    }
    .left {
      padding-right: 20px;
      border-right: 3px solid #fff;
    }
    ul {
      padding-left: 40px;
      li {
        list-style-type: circle;
        margin-bottom: 5px;
      }
    }
  }
}

.demographic-data {
  h3.widget-title {
    text-align: center;
  }
  h5 {
    font-size: 16px;
    color: $blueish-gray-600;
  }
}

.product-view {
  max-width: 1000px;
  margin: 0 auto;
}

@include respond-above(sm) {
  .line-chart-section {
    display: grid;
    grid-template-columns: 170px 1fr;
    column-gap: 20px;
  }
  .social-networks-wrapper {
    .line-chart-data {
      border-right: 1px solid $blueish-gray-200;
      .data {
        text-align: left;
        padding-top: 15px;
        padding-bottom: 15px;
        &:nth-child(2) {
          border-top: 1px solid $blueish-gray-200;
          border-bottom: 1px solid $blueish-gray-200;
        }
      }
    }
  }
  .demographic-data {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 30px;
    > h3.widget-title {
      grid-column: 1 / -1;
      margin-bottom: 20px;
    }
  }
  .two-column {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 30px;
    h3 {
      text-align: center;
    }
  }
}
</style>

<style lang="scss">
.social-ad-preview {
  height: 485px;
  .el-carousel__container {
    min-height: 450px !important;
  }
}
</style>
